<template>
  <v-flex class="version-tag">
    {{ $t('about.poweredBy') }} - {{ $t('about.version') }} {{ versionNumber }}
  </v-flex>
</template>

<script>
export default {
  name: 'version',
  data() {
    return {
      versionNumber: process.env.VUE_APP_VERSION,
    };
  },
};
</script>
<style lang="scss" scoped>
  .version-tag {
    position: fixed;
    bottom: 0;
    right: 0;

    color: #919191;
    font-size: 12px;
    margin-top: -20px;
    padding-right: 15px;
    text-align: right;

    &.mobile {
      text-align: center;
    }
  }
</style>
